var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2141_4458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78075 66.1442L7.37793 65.4499L20.3903 20.4122C20.582 19.7486 21.2753 19.3662 21.9389 19.5579C22.6024 19.7495 22.9848 20.4429 22.7932 21.1064L9.78075 66.1442Z",
    fill: "#555A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59836 74.3271C13.346 74.3271 17.1948 70.4784 17.1948 65.7307C17.1948 60.983 13.346 57.1343 8.59836 57.1343C3.8507 57.1343 0.00195312 60.983 0.00195312 65.7307C0.00195312 70.4784 3.8507 74.3271 8.59836 74.3271Z",
    fill: "url(#paint0_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59824 72.9051C12.5606 72.9051 15.7727 69.693 15.7727 65.7307C15.7727 61.7684 12.5606 58.5563 8.59824 58.5563C4.63592 58.5563 1.42383 61.7684 1.42383 65.7307C1.42383 69.693 4.63592 72.9051 8.59824 72.9051Z",
    fill: "url(#paint1_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4273 59.4104C14.663 60.6829 14.6147 62.0283 14.2308 63.3563C12.913 67.9173 8.1472 70.5466 3.58614 69.2287C2.25803 68.845 1.0942 68.1685 0.143555 67.2903C0.717614 70.3883 2.97944 73.0549 6.21238 73.989C10.7734 75.3067 15.5392 72.6776 16.8569 68.1166C17.7911 64.8836 16.7417 61.5482 14.4273 59.4104Z",
    fill: "url(#paint2_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0537 67.6257H37.5527V20.7457C37.5527 20.055 38.1127 19.4952 38.8032 19.4952C39.4939 19.4952 40.0537 20.0552 40.0537 20.7457V67.6257Z",
    fill: "#555A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8025 76.1529C43.5501 76.1529 47.3989 72.3042 47.3989 67.5565C47.3989 62.8088 43.5501 58.9601 38.8025 58.9601C34.0548 58.9601 30.2061 62.8088 30.2061 67.5565C30.2061 72.3042 34.0548 76.1529 38.8025 76.1529Z",
    fill: "url(#paint3_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8033 74.7309C42.7656 74.7309 45.9777 71.5188 45.9777 67.5565C45.9777 63.5942 42.7656 60.3821 38.8033 60.3821C34.841 60.3821 31.6289 63.5942 31.6289 67.5565C31.6289 71.5188 34.841 74.7309 38.8033 74.7309Z",
    fill: "url(#paint4_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6486 59.8668C43.2283 61.0239 43.5552 62.3298 43.5552 63.7122C43.5552 68.4598 39.7065 72.3086 34.9588 72.3086C33.5765 72.3086 32.2706 71.9818 31.1133 71.4021C32.5247 74.2191 35.4379 76.1531 38.803 76.1531C43.5506 76.1531 47.3994 72.3044 47.3994 67.5568C47.3996 64.1913 45.4656 61.2782 42.6486 59.8668Z",
    fill: "url(#paint5_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2461 67.6257H54.7451V20.7457C54.7451 20.055 55.3051 19.4952 55.9956 19.4952C56.6863 19.4952 57.2461 20.0552 57.2461 20.7457V67.6257Z",
    fill: "#555A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9958 76.1529C60.7435 76.1529 64.5922 72.3042 64.5922 67.5565C64.5922 62.8088 60.7435 58.9601 55.9958 58.9601C51.2482 58.9601 47.3994 62.8088 47.3994 67.5565C47.3994 72.3042 51.2482 76.1529 55.9958 76.1529Z",
    fill: "url(#paint6_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9957 74.7309C59.958 74.7309 63.1701 71.5188 63.1701 67.5565C63.1701 63.5942 59.958 60.3821 55.9957 60.3821C52.0334 60.3821 48.8213 63.5942 48.8213 67.5565C48.8213 71.5188 52.0334 74.7309 55.9957 74.7309Z",
    fill: "url(#paint7_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.841 59.8668C60.4207 61.0239 60.7475 62.3298 60.7475 63.7122C60.7475 68.4598 56.8989 72.3086 52.1511 72.3086C50.7688 72.3086 49.463 71.9818 48.3057 71.4021C49.7171 74.2191 52.6301 76.1531 55.9954 76.1531C60.743 76.1531 64.5916 72.3044 64.5916 67.5568C64.592 64.1913 62.658 61.2782 59.841 59.8668Z",
    fill: "url(#paint8_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4384 67.6257H71.9375V20.7457C71.9375 20.055 72.4974 19.4952 73.188 19.4952C73.8787 19.4952 74.4384 20.0552 74.4384 20.7457V67.6257Z",
    fill: "#555A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1882 76.1529C77.9359 76.1529 81.7846 72.3042 81.7846 67.5565C81.7846 62.8088 77.9359 58.9601 73.1882 58.9601C68.4405 58.9601 64.5918 62.8088 64.5918 67.5565C64.5918 72.3042 68.4405 76.1529 73.1882 76.1529Z",
    fill: "url(#paint9_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1881 74.7309C77.1504 74.7309 80.3625 71.5188 80.3625 67.5565C80.3625 63.5942 77.1504 60.3821 73.1881 60.3821C69.2258 60.3821 66.0137 63.5942 66.0137 67.5565C66.0137 71.5188 69.2258 74.7309 73.1881 74.7309Z",
    fill: "url(#paint10_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0334 59.8668C77.6131 61.0239 77.9399 62.3298 77.9399 63.7122C77.9399 68.4598 74.0913 72.3086 69.3435 72.3086C67.9612 72.3086 66.6553 71.9818 65.498 71.4021C66.9095 74.2191 69.8225 76.1531 73.1877 76.1531C77.9353 76.1531 81.7842 72.3044 81.7842 67.5568C81.7843 64.1913 79.8502 61.2782 77.0334 59.8668Z",
    fill: "url(#paint11_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.324 19.1317C83.324 17.3949 81.9161 15.987 80.1793 15.987H11.4736V22.2764H80.1793C81.9161 22.2762 83.324 20.8684 83.324 19.1317Z",
    fill: "url(#paint12_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1609 20.1259C82.7445 21.3748 81.5681 22.2764 80.1793 22.2764H11.4736V17.9755H80.1793C81.5683 17.9755 82.7446 18.8769 83.1609 20.1259Z",
    fill: "url(#paint13_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5091 22.2762H14.2197V15.987L20.5091 22.2762Z",
    fill: "url(#paint14_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0823 24.4159C13.0008 24.4159 15.3667 22.05 15.3667 19.1315C15.3667 16.213 13.0008 13.8471 10.0823 13.8471C7.16376 13.8471 4.79785 16.213 4.79785 19.1315C4.79785 22.05 7.16376 24.4159 10.0823 24.4159Z",
    fill: "url(#paint15_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0822 23.5421C12.518 23.5421 14.4926 21.5675 14.4926 19.1317C14.4926 16.696 12.518 14.7214 10.0822 14.7214C7.64646 14.7214 5.67188 16.696 5.67188 19.1317C5.67188 21.5675 7.64646 23.5421 10.0822 23.5421Z",
    fill: "url(#paint16_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4464 14.4044C12.8029 15.1158 13.0037 15.9185 13.0037 16.7682C13.0037 19.6867 10.6378 22.0527 7.71929 22.0527C6.86959 22.0527 6.06682 21.8518 5.35547 21.4954C6.22317 23.2271 8.01382 24.4159 10.0826 24.4159C13.0011 24.4159 15.367 22.05 15.367 19.1315C15.367 17.0629 14.1779 15.2721 12.4464 14.4044Z",
    fill: "url(#paint17_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7161 24.4159C87.6346 24.4159 90.0005 22.05 90.0005 19.1315C90.0005 16.213 87.6346 13.8471 84.7161 13.8471C81.7976 13.8471 79.4316 16.213 79.4316 19.1315C79.4316 22.05 81.7976 24.4159 84.7161 24.4159Z",
    fill: "url(#paint18_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.716 23.5421C87.1518 23.5421 89.1264 21.5675 89.1264 19.1317C89.1264 16.696 87.1518 14.7214 84.716 14.7214C82.2802 14.7214 80.3057 16.696 80.3057 19.1317C80.3057 21.5675 82.2802 23.5421 84.716 23.5421Z",
    fill: "url(#paint19_linear_2141_4458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0792 14.4044C87.4357 15.1158 87.6365 15.9185 87.6365 16.7682C87.6365 19.6867 85.2706 22.0527 82.3521 22.0527C81.5024 22.0527 80.6996 21.8518 79.9883 21.4954C80.856 23.2271 82.6466 24.4159 84.7154 24.4159C87.6339 24.4159 89.9998 22.05 89.9998 19.1315C89.9998 17.0629 88.8109 15.2721 87.0792 14.4044Z",
    fill: "url(#paint20_linear_2141_4458)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2141_4458",
    x1: 6.38103,
    y1: 61.7742,
    x2: 13.9854,
    y2: 75.5688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2141_4458",
    x1: 9.16241,
    y1: 67.4512,
    x2: 6.15572,
    y2: 58.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2141_4458",
    x1: 7.94893,
    y1: 69.0083,
    x2: 25.4136,
    y2: 51.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2141_4458",
    x1: 35.5861,
    y1: 64.3401,
    x2: 46.7196,
    y2: 75.4738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2141_4458",
    x1: 39.8346,
    y1: 69.0187,
    x2: 34.5306,
    y2: 61.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2141_4458",
    x1: 39.1018,
    y1: 70.851,
    x2: 50.9179,
    y2: 48.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2141_4458",
    x1: 52.7795,
    y1: 64.3401,
    x2: 63.913,
    y2: 75.4738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2141_4458",
    x1: 57.027,
    y1: 69.0187,
    x2: 51.723,
    y2: 61.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2141_4458",
    x1: 56.2943,
    y1: 70.851,
    x2: 68.1103,
    y2: 48.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2141_4458",
    x1: 69.9719,
    y1: 64.3401,
    x2: 81.1056,
    y2: 75.4739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2141_4458",
    x1: 74.2196,
    y1: 69.0187,
    x2: 68.9156,
    y2: 61.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2141_4458",
    x1: 73.4865,
    y1: 70.851,
    x2: 85.3026,
    y2: 48.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2141_4458",
    x1: 47.3988,
    y1: 16.107,
    x2: 47.3988,
    y2: 22.1876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2141_4458",
    x1: 49.0063,
    y1: 10.2681,
    x2: 46.256,
    y2: 24.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2141_4458",
    x1: 21.0269,
    y1: 25.9389,
    x2: 11.5395,
    y2: 16.4513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2141_4458",
    x1: 8.10509,
    y1: 17.1545,
    x2: 14.9493,
    y2: 23.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2141_4458",
    x1: 11.8088,
    y1: 20.8583,
    x2: 7.02646,
    y2: 16.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2141_4458",
    x1: 10.2659,
    y1: 21.1569,
    x2: 17.5296,
    y2: 7.64754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2141_4458",
    x1: 82.7387,
    y1: 17.1545,
    x2: 89.5829,
    y2: 23.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2141_4458",
    x1: 86.4424,
    y1: 20.8583,
    x2: 81.6603,
    y2: 16.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2141_4458",
    x1: 84.8988,
    y1: 21.1569,
    x2: 92.1625,
    y2: 7.64754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2141_4458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingBall);
export default __webpack_public_path__ + "static/media/waitingBall.a290c9474d7888a9e0ffe9a958e8f5be.svg";
export { ForwardRef as ReactComponent };